import http from './api'

export type RoomMessageType = 'system' | 'user'

export interface RoomMessage {
  id: string
  _id: string
  roomId: string
  content: string
  messageType: RoomMessageType
  authorId: string | null
  authorName: string | null
  readerIds: string[]
  readers: string[]
  createdAt: string
}

class RoomMessagesService {
  async list(roomId: string): Promise<RoomMessage[]> {
    const res = await http.get<RoomMessage[]>(`/room-messages/${roomId}`)
    return res.data
  }

  async send(roomId: string, content: string): Promise<RoomMessage> {
    const res = await http.post<RoomMessage>(`/room-messages/${roomId}`, { content })
    return res.data
  }

  async markAllRead(roomId: string): Promise<void> {
    await http.get(`/room-messages/read/${roomId}`)
  }

  async unreadCount(roomId: string): Promise<number> {
    const res = await http.get<{ count: number }>(`/room-messages/unread-count/${roomId}`)
    return res.data.count
  }
}

const roomMessagesService = new RoomMessagesService()
export default roomMessagesService
